import {useDispatch} from 'react-redux';

import {setResultsData} from './searchSlice';

const useSearchActions = () => {
  const dispatch = useDispatch();

  const setResultsDataAction = (results) => {
    dispatch(setResultsData(results));
  };

  return {
    setResultsDataAction,
  };
};

export default useSearchActions;
